import { createApp } from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import router from './routes'
import i18n from './components/i8n.js'; // 确保正确导入 i18n 实例
import './style.css'
// import { GoogleMap, Marker } from 'vue3-google-map';



  createApp(App)
  .use(router) // 注册路由
  .use(i18n)
  .use(ElementPlus)
  // .component('GoogleMap', GoogleMap)
  // .component('Marker', Marker)
  .mount('#app');



